/**
 * Portuguese (Brazil) translations
 */
export default {
  common: {
    loading: 'Carregando...',
    save: 'Salvar',
    cancel: 'Cancelar',
    delete: 'Excluir',
    edit: 'Editar',
    add: 'Adicionar',
    close: 'Fechar',
    confirm: 'Confirmar',
    back: 'Voltar',
    next: 'Avançar',
    yes: 'Sim',
    no: 'Não',
    search: 'Buscar',
    filter: 'Filtrar',
    all: 'Todos',
    none: 'Nenhum',
    error: 'Erro',
    success: 'Sucesso',
    warning: 'Aviso',
    info: 'Informação',
    update: 'Atualizar',
    current: 'atual',
  },
  welcome: {
    title: 'BitTask',
    subtitle: 'Pixel Todo',
    start: 'Iniciar',
    skipForever: 'Não mostrar novamente',
    version: 'v1.0.0 - Pronto para Offline',
  },
  home: {
    title: 'Tarefas',
    newTask: 'Nova Tarefa',
    noTasks: 'Nenhuma tarefa ainda',
    addFirstTask: 'Adicione sua primeira tarefa!',
    completed: 'Concluídas',
    pending: 'Pendentes',
    total: 'Total',
    filterAll: 'Todas',
    filterActive: 'Ativas',
    filterCompleted: 'Concluídas',
  },
  task: {
    title: 'Título',
    titlePlaceholder: 'Digite o título da tarefa',
    titleRequired: 'Título é obrigatório',
    description: 'Descrição',
    descriptionPlaceholder: 'Adicione uma descrição (opcional)',
    priority: 'Prioridade',
    priorityLow: 'Baixa',
    priorityMedium: 'Média',
    priorityHigh: 'Alta',
    tags: 'Tags',
    tagsPlaceholder: 'Separe as tags por vírgula',
    completed: 'Concluída',
    createdAt: 'Criada em',
    updatedAt: 'Atualizada em',
    deleteConfirm: 'Excluir esta tarefa?',
    deleteTask: 'Excluir Tarefa',
    deleteTaskConfirm: 'Tem certeza que deseja excluir esta tarefa? Esta ação não pode ser desfeita.',
    deleteAttachment: 'Excluir Anexo',
    deleteAttachmentConfirm: 'Tem certeza que deseja excluir este anexo? Esta ação não pode ser desfeita.',
    attachments: 'Anexos',
    noAttachments: 'Nenhum anexo',
    addAttachment: 'Adicionar anexo',
  },
  attachments: {
    title: 'Anexos',
    addFile: 'Adicionar Arquivo',
    addLink: 'Adicionar Link',
    takePhoto: 'Tirar Foto',
    uploadImage: 'Enviar Imagem',
    uploadAudio: 'Enviar Áudio',
    uploadPdf: 'Enviar PDF',
    deleteConfirm: 'Excluir este anexo?',
    previewUnavailable: 'Prévia indisponível',
    openLink: 'Abrir link',
    fileTooBig: 'Arquivo muito grande (máximo {{size}})',
    invalidType: 'Tipo de arquivo não suportado',
    linkPlaceholder: 'Digite ou cole uma URL',
    addLinkButton: 'Adicionar',
  },
  camera: {
    title: 'Câmera',
    capture: 'Capturar',
    retake: 'Refazer',
    usePhoto: 'Usar Foto',
    switchCamera: 'Trocar Câmera',
    permissionDenied: 'Acesso à câmera negado',
    permissionHelp: 'Habilite as permissões da câmera nas configurações do navegador.',
  },
  settings: {
    title: 'Configurações',
    theme: 'Tema',
    themeSlso8: 'SLSO8',
    themeOriginal: 'Original',
    mode: 'Modo',
    modeLight: 'Claro',
    modeDark: 'Escuro',
    modeSystem: 'Sistema',
    currentMode: 'Atual: {{mode}}',
    language: 'Idioma',
    storage: 'Armazenamento',
    maxFileSize: 'Tamanho máximo',
    compressImages: 'Comprimir imagens',
    imageQuality: 'Qualidade da imagem',
    appStatus: 'Status do App',
    installed: 'Instalado',
    network: 'Rede',
    online: 'Online',
    offline: 'Offline',
    pendingSync: 'Sincronização pendente',
    operations: 'operações',
    installApp: 'Instalar App',
    showWelcome: 'Mostrar tela de boas-vindas',
    about: 'Sobre',
    version: 'BitTask v1.0.0',
    aboutDescription: 'Um app PWA de tarefas em pixel-art com arquitetura offline-first.',
    builtWith: 'Construído com React, TypeScript, Dexie e Vite.',
  },
  errors: {
    generic: 'Algo deu errado',
    networkError: 'Erro de conexão',
    notFound: 'Não encontrado',
    taskNotFound: 'Tarefa não encontrada',
    failedToCreate: 'Falha ao criar',
    failedToUpdate: 'Falha ao atualizar',
    failedToDelete: 'Falha ao excluir',
    failedToLoad: 'Falha ao carregar',
  },
  boards: {
    title: 'Quadros',
    manage: 'Gerenciar Quadros',
    create: 'Novo Quadro',
    rename: 'Renomear',
    delete: 'Excluir Quadro',
    deleteConfirm: 'Tem certeza que deseja excluir este quadro? Todas as tarefas serão movidas para outro quadro.',
    cannotDeleteLast: 'Não é possível excluir o último quadro',
    transfer: 'Mover para...',
    selectBoard: 'Selecione um quadro',
    namePlaceholder: 'Nome do quadro',
    nameRequired: 'Nome do quadro é obrigatório',
  },
  subtasks: {
    title: 'Checklist',
    add: 'Adicionar',
    placeholder: 'Adicionar item...',
    progress: '{{completed}}/{{total}}',
  },
  share: {
    title: 'Conteúdo Compartilhado',
    receivedContent: 'Conteúdo recebido',
    createTask: 'Criar Nova Tarefa',
    assignToTask: 'Atribuir a Tarefa Existente',
    dismiss: 'Descartar',
    searchPlaceholder: 'Buscar por #ID ou título...',
    untitledTask: 'Item Compartilhado',
    errorReceiving: 'Erro ao receber conteúdo compartilhado',
    timeout: 'Tempo limite excedido',
  },
  speech: {
    start: 'Iniciar entrada de voz',
    stop: 'Parar entrada de voz',
    notSupported: 'Entrada de voz não suportada neste navegador',
  },
} as const;
